import React, { useState, useMemo } from 'react';
import Title from '../Title';
import Cards from '../Cards';
import jobs from '../../data/jobs';
import { useTranslation } from 'react-i18next';

const CareersSection = () => {
  const { t } = useTranslation();
  const allCategory = t('careers.careers_categories.category_1.title');
  const [selectedCategory, setSelectedCategory] = useState(allCategory);

  const jobData = t('careers.jobs', { returnObjects: true });

  const combinedJobs = useMemo(() => {
    return Object.entries(jobData).map(([key, job]) => {
      const localJob = jobs.find((j) => j.slug === job.slug);
      return {
        ...job,
        image: localJob?.image || '',
      };
    });
  }, [jobData]);

  const categories = useMemo(() => {
    return Array.from({ length: 5 }, (_, i) =>
      t(`careers.careers_categories.category_${i + 1}.title`)
    );
  }, [t]);

  const filteredJobs =
  selectedCategory === allCategory
    ? combinedJobs
    : combinedJobs.filter((job) => job.category === selectedCategory);


  return (
    <div className='flex flex-col p-6 md:p-12 gap-6 md:gap-12'>
      <Title>{t('careers.careers_title')}</Title>
      <Cards
        items={filteredJobs}
        linkPrefix='/careers/job'
        imageKey='image'
        titleKey='title'
        linkKey='slug'
        emptyMessage='No open roles here'
        categories={categories}
        category={selectedCategory}
        setCategory={setSelectedCategory}
        t={t}
        translate={true}
      />
    </div>
  );
};

export default CareersSection;
